import { onBeforeUnmount } from "vue";

import type { Action } from "@/action/types";
import type { AdHocAction, ShortcutOptions } from "@/utils/shortcut/shortcuts";
import { registerShortcut, unregisterShortcuts } from "@/utils/shortcut/shortcuts";

export function useShortcuts() {
  const component = Symbol();

  function register(action: Action<[], unknown> | AdHocAction, options?: ShortcutOptions) {
    registerShortcut(component, action, options);
  }

  onBeforeUnmount(() => unregisterShortcuts(component));

  return { registerShortcut: register };
}
